const CATEGORIES = [
  "salary",
  "tip",
  "project",
  "groceries",
  "food",
  "movie",
  "bills",
  "medical",
  "fee",
  "tax",
  "other",
];

export default CATEGORIES;
